"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetFacade_1 = require("../Widget/WidgetFacade");
/**
 * Widget facade factory.
 */
class WidgetFacadeFactory {
    /**
     * Constructs facade factory.
     *
     * @param {ExtendableProvider} extendableManager
     * @param {ContainerAwareFactory} containerAwareFactory
     */
    constructor(extendableManager, containerAwareFactory) {
        this.extendableManager = extendableManager;
        this.containerAwareFactory = containerAwareFactory;
    }
    /**
     * Creates new widget facade.
     *
     * @param {WidgetState} widgetState
     * @param {WidgetConfig} widgetConfig
     * @param {EventContainerContext} eventContext
     * @return {WidgetFacade}
     */
    create(widgetState, widgetConfig, eventContext) {
        try {
            return this.doCreate(widgetState, widgetConfig, eventContext);
        }
        catch (err) {
            console.error(`Failed creating widget facade.`);
            throw err;
        }
    }
    /**
     * Creates new widget facade.
     *
     * @param {WidgetState} widgetState
     * @param {WidgetConfig} widgetConfig
     * @param {EventContainerContext} eventContext
     * @return {WidgetFacade}
     */
    doCreate(widgetState, widgetConfig, eventContext) {
        const widgetFacadeType = this.extendableManager.getExtended(WidgetFacade_1.default);
        const instance = this.containerAwareFactory.create(widgetFacadeType, widgetState, widgetConfig, eventContext);
        // Construct a replica object that serves as a private accessor to the facade
        // instance to restrict full access to the widget or dependencies of the
        // facade.
        const privateFacade = {};
        const privateMethods = widgetFacadeType.getPrivateMethods().concat(["constructor"]);
        let props = [];
        let obj = instance;
        do {
            props = props.concat(Object.getOwnPropertyNames(obj));
        } while (obj = Object.getPrototypeOf(obj));
        props.sort()
            // Filter out unwanted methods
            .filter(function (e, i, arr) {
            if (e !== arr[i + 1] && typeof obj !== Object.prototype &&
                e.charAt(0) !== "_" && typeof instance[e] === "function" &&
                !privateMethods.includes(e)) {
                return true;
            }
        })
            // Add only wanted methods.
            .forEach((fn) => {
            privateFacade[fn] = instance[fn].bind(instance);
        });
        return privateFacade;
    }
}
exports.default = WidgetFacadeFactory;
